import moment from 'moment'
import { IEvent } from '../../store/events/interfaces'

export const getEventsByWeek = (events: IEvent[]) => {
  const firstEvent = events.find(event => event.start)
  const lastEvent = events.filter(event => event.start).slice(-1)[0]

  const maxDate = lastEvent?.start
    ? moment(lastEvent.start)
      .startOf('isoWeek')
      .add(1, 'week')
      .format('GGGG;WW')
    : '1970;1'

  const eventsByWeek: { [key: string]: IEvent[] } = {
    [maxDate]: [],
  }
  if (firstEvent && lastEvent) {
    const start = moment(firstEvent.start).startOf('isoWeek')
    const end = moment(lastEvent.start).startOf('isoWeek')

    const current = start.clone()
    while (current <= end) {
      eventsByWeek[current.format('GGGG;WW')] = []
      current.add(1, 'week')
    }
  }
  events.forEach(event =>
    eventsByWeek[
      event.start ? moment(event.start).format('GGGG;WW') : maxDate
      ].push(event),
  )
  return [eventsByWeek, maxDate]
}
